export function ApplyPage() {
  return (
    <div>
      <h1>Request Trade Execution Page</h1>
    </div>
  );
}
